import axios from 'axios';

let authService = {
  getToken() {
    return axios({
      method: `get`,
      url: `${process.env.VUE_APP_RETIREMENTAPI}/auth/token`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then(function (response) {
        return response.data
      }).catch(() => {
        return false
      });
  },
};

export {authService}